/* eslint-disable react/jsx-props-no-spreading */
/**
 *
 * TimePicker
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'rc-picker';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import { makeStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import useDateMonthPickerLocale from 'components/useDateMonthPickerLocale';
import './styles.css';
import { hoursToDatetime, datetimeToHours } from './utils';

const useStyles = makeStyles(theme => ({
  assessment: {
    backgroundColor: '#FFFFFF',
    borderRadius: 4,
    margin: '8px 0',
    padding: 8,
    border: '1px solid #D8D8D8',
    width: '100%',
    fontSize: 20,
    [theme.breakpoints.down('600')]: {
      width: '100%',
    },
  },
  root: {
    minWidth: 130,
    '& input': {
      height: '1.2em',
    },
    '& select': {
      height: '1.2em',
      lineHeight: '1.35',
    },
  },
  padded: {
    '& input': {
      padding: '16px 14px',
    },
    '& select': {
      padding: '16px 14px',
    },
  },
  fontSize: {
    fontSize: '1.063rem',
  },
  placeholderColor: {
    color: '#999999',
  },
  shrinkColor: {
    color: '#4B4B4B',
  },
}));

function TimePicker({ value, placeholder, onChange }) {
  const classes = useStyles();
  const locale = useDateMonthPickerLocale();

  return (
    <DatePicker
      className={classes.input}
      locale={locale}
      format="hh:mmA"
      placeholder={placeholder}
      generateConfig={momentGenerateConfig}
      value={hoursToDatetime(value)}
      use12Hours
      showSecond={false}
      inputRender={props => {
        const finalProps = {
          id: 'time',
          name: 'time',
          onChange,
          fullWidth: true,
          ...props,
          variant: 'outlined',
        };

        return (
          <InputBase classes={{ root: classes.assessment }} {...finalProps} />
        );
      }}
      onSelect={date => {
        if (!date) {
          return onChange(null);
        }

        return onChange(datetimeToHours(date));
      }}
      picker="time"
    />
  );
}

TimePicker.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

export default TimePicker;
